export enum LegacyScriptTagConfiguration {
	Unknown = "Unknown",
	Disabled = "Disabled",
	ModalsOnly = "ModalsOnly",
	FloaterOnly = "FloaterOnly",
	ModalsAndWidget = "ModalsAndWidget",
	FloaterAndWidget = "FloaterAndWidget"
}
